'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/PopUpBox.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
me={this} 
modal={true/false} 
Id={this.props.Id}  
Title={} 
Content={}                                           

optional:
Width={330} Z={9999}
*/
var PopUpBox = function (_Component) {
    _inherits(PopUpBox, _Component);

    function PopUpBox(props) {
        _classCallCheck(this, PopUpBox);

        var _this = _possibleConstructorReturn(this, (PopUpBox.__proto__ || Object.getPrototypeOf(PopUpBox)).call(this, props));

        _this.state = {};
        _this.state.Open = false;
        _this.messen = _this.messen.bind(_this);
        _this.state.drag = false;
        _this.state.Content = _this.props.Content;
        return _this;
    }

    _createClass(PopUpBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.messen();
            this.dragElement(document.getElementById("PopUpBox" + this.props.Id));

            window.addEventListener("resize", this.messen);

            if (this.props.modal === true) {
                this.toggleModal();
            }

            var me = this;
            (0, _jquery2.default)(document).keyup(function (e) {
                switch (e.which) {
                    case 27:
                        {
                            //ESC
                            if (document.getElementById('pickerContainer')) {
                                if (document.getElementById('pickerContainer').children.length === 0) {
                                    me.props.me.Close();
                                    break;
                                } else {
                                    if (me.props.me.state.isPicker) {
                                        me.props.me.Close();
                                        break;
                                    }
                                }
                            }break;
                        }
                    default:
                        break;
                }
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.drag === false) {
                this.messen();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.getElementById('pickerContainer').children.length === 0) {
                (0, _jquery2.default)(document).unbind("keyup");
            }

            if (this.props.modal === true) {
                this.toggleModal();
            }
        }
    }, {
        key: 'messen',
        value: function messen() {
            if (document.getElementById("PopUpBox" + this.props.Id)) {
                var newX = document.getElementById("PopUpBox" + this.props.Id).offsetWidth / 2;
                var oldX = document.getElementById("PopUpBox" + this.props.Id).style.marginLeft;
                if (newX !== Math.abs(Number(oldX.substr(0, oldX.length - 2)))) {
                    var top = null;
                    var left = null;

                    var windowWidth = window.innerWidth / 2;
                    var windowHeight = window.innerHeight / 2;

                    var width = document.getElementById("PopUpBox" + this.props.Id).offsetWidth / 2;
                    var height = document.getElementById("PopUpBox" + this.props.Id).clientHeight / 2;

                    if (width > windowWidth) {
                        left = -windowWidth;
                    } else {
                        left = -width;
                    }

                    if (height > windowHeight) {
                        top = -windowHeight;
                    } else {
                        top = -height;
                    }

                    if (this.props.Id.indexOf("dp", 0) > -1) {
                        document.getElementById("PopUpBox" + this.props.Id).style.position = "fixed";
                        document.getElementById("PopUpBox" + this.props.Id).style.top = "50%";
                        document.getElementById("PopUpBox" + this.props.Id).style.left = "50%";
                    } else {
                        document.getElementById("PopUpBox" + this.props.Id).style.marginLeft = left + "px";
                        document.getElementById("PopUpBox" + this.props.Id).style.marginTop = top + "px";
                    }
                }
            }
        }
    }, {
        key: 'toggleModal',
        value: function toggleModal() {
            var modal = document.querySelector(".modal");
            modal.classList.toggle("show-modal");
        }

        //#region drag&drop

    }, {
        key: 'dragElement',
        value: function dragElement(elmnt) {
            //https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_draggable 08.08.2018
            var pos1 = 0,
                pos2 = 0,
                pos3 = 0,
                pos4 = 0;
            var me = this;
            if (document.getElementById(elmnt.id + "Header")) {
                /* if present, the header is where you move the DIV from:*/
                document.getElementById(elmnt.id + "Header").onmousedown = dragMouseDown;
            } else {
                /* otherwise, move the DIV from anywhere inside the DIV:*/
                //elmnt.onmousedown = dragMouseDown;
            }

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                // get the mouse cursor position at startup:
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                // call a function whenever the cursor moves:
                document.onmousemove = elementDrag;
                me.setState({ drag: true });
            }

            function elementDrag(e) {
                e = e || window.event;
                e.preventDefault();
                // calculate the new cursor position:
                pos1 = pos3 - e.clientX; //Differenz -> Anzahl der Pixel 
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;

                var left = elmnt.style.marginLeft;
                left = Number(left.replace("px", ''));
                var top = elmnt.style.marginTop;
                top = Number(top.replace("px", ''));

                // set the element's new position:
                elmnt.style.marginLeft = left - pos1 + "px";
                elmnt.style.marginTop = top - pos2 + "px";

                //elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
                //elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
            }

            function closeDragElement() {
                /* stop moving when mouse button is released:*/
                document.onmouseup = null;
                document.onmousemove = null;
            }
        }
        //#endregion

    }, {
        key: 'render',
        value: function render() {
            var Style = null;

            if (this.props.Width && !this.props.Z) {
                Style = { width: this.props.Width };
            } else {
                if (this.props.Z && !this.props.Width) {
                    Style = { zIndex: this.props.Z };
                } else {
                    if (this.props.Width && this.props.Z) {
                        Style = { zIndex: this.props.Z, width: this.props.Width };
                    }
                }
            }

            (0, _jquery2.default)("#Content").css("opacity", "0.4");

            var className = 'standart';
            if (this.props.modal === true) {
                className = "modal";
            }
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    {
                        id: "PopUpBox" + this.props.Id,
                        className: "PopUpBox",
                        style: Style,
                        tabIndex: -1
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            id: "PopUpBox" + this.props.Id + "Header",
                            className: "PopUpBoxTitle" },
                        this.props.Title
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "PopUpBoxMessageContainer" },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { style: { float: "right", lineHeight: "30px", paddingRight: "20px", paddingTop: "10px" } },
                                        _react2.default.createElement('div', {
                                            id: "LoadingIconPopUp",
                                            className: 'hide' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        this.state.Content
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement('div', { id: "pickerContainer" })
            );
        }
    }]);

    return PopUpBox;
}(_react.Component);

exports.default = PopUpBox;